"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genSym = exports.macroexpand = void 0;
const macro_1 = require("../interpreter/macro");
const util_1 = require("../interpreter/util");
const sExpression_1 = require("../sExpression");
const listHelpers_1 = require("../utils/listHelpers");
exports.macroexpand = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'macroexpand',
    callSignature: {
        style: 'fixed-args',
        numParams: 1
    },
    body: function* (args, context) {
        const form = args[0];
        if (form.type !== 'pair') {
            throw new Error(`macroexpand expected a list as the only argument, but got ${form.type}`);
        }
        const list = listHelpers_1.flattenPairToList(form);
        if (list.type !== 'List') {
            throw new Error(`macroexpand expected a list as the only argument, but got an improper list`);
        }
        if (list.value.length === 0) {
            throw new Error(`macroexpand expected a non-empty list as the only argument, but got an empty list`);
        }
        const macroName = list.value[0].value;
        if (macroName.type !== 'symbol') {
            throw new Error(`first element in the argument list must be a macro name`);
        }
        const macro = util_1.getVariable(context, macroName.value);
        if (!macro || macro.type !== 'macro') {
            throw new Error(`no macro named ${macroName.value}`);
        }
        return yield* macro_1.expandMacro(context, macro, list.value.map(element => element.value).slice(1), context.runtime.nodes[0]);
    }
};
exports.genSym = {
    type: 'procedure',
    variant: 'BuiltInProcedure',
    name: 'gensym',
    callSignature: {
        style: 'fixed-args',
        numParams: 0
    },
    body: (_args, context) => {
        const seqNumber = context.runtime.nextUniqueSymbolNumber++;
        const symbolName = util_1.syntheticIdentifierPrefix + seqNumber;
        return sExpression_1.makeSymbol(symbolName, false);
    }
};
//# sourceMappingURL=macro.js.map